import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { useDispatch, useSelector } from 'react-redux';
import style from '../index.module.scss';
import { useI18n } from '@lib/i18n';
import AdvisorNotesModalController from '@components/AdvisorNotesModalController';
import AuthenticationService from '@lib/auth/AuthenticationService';
import checkUserIsAdvisor from '@actions/advisor/isAdvisor';

export default function AdvisorNotesMenuItem() {
	const router = useRouter();
	const dispatch = useDispatch();
	const { t } = useI18n();

	const { authenticated, isOnline } = useSelector((state) => state.user);

	const [isAdvisor, setIsAdvisor] = useState(false);
	const [hasCheckedAdvisor, setHasCheckedAdvisor] = useState(false);

	const { slug, isAdvisorView } = router.query;

	const isProspectusView = router.pathname === '/prospectus/[slug]';
	const advisorViewEnabled = isAdvisorView === 'true';
	const prospectusSlug = Array.isArray(slug) ? slug[0] : slug;

	useEffect(() => {
		const getAuthToken = async () => {
			const auth = new AuthenticationService();

			let token = auth.getJwtTokenFromStorage();

			if (!token) {
				await auth.refreshToken()(dispatch);
				token = auth.getJwtTokenFromStorage();
			}

			return token || '';
		};

		const verifyAdvisor = async () => {
			if (!isProspectusView || !advisorViewEnabled || !authenticated || !isOnline) {
				setHasCheckedAdvisor(true);
				return;
			}

			const token = await getAuthToken();

			if (!token) {
				setIsAdvisor(false);
				setHasCheckedAdvisor(true);
				return;
			}

			const result = await checkUserIsAdvisor(token);

			setIsAdvisor(result);
			setHasCheckedAdvisor(true);
		};

		verifyAdvisor();
	}, [authenticated, advisorViewEnabled, dispatch, isOnline, isProspectusView]);

	if (!isProspectusView) {
		return;
	}

	if (!isOnline) {
		return;
	}

	if (!authenticated) {
		return;
	}

	if (!advisorViewEnabled) {
		console.log(	);
		return;
	}

	if (!prospectusSlug) {
		return;
	}

	if (!hasCheckedAdvisor || !isAdvisor) {
		return;
	}

	return (
		<AdvisorNotesModalController>
			{({ openAdvisorNotes }) => (
				<ul id="save_or_share">
					<li>
						<button
							type="button"
							disabled={!authenticated}
							onClick={() => openAdvisorNotes(prospectusSlug)}
							className={`saveShareBtn btnComponent`}
						>
							<span className={style.text}>
								{t('header.advisor_notes', 'Notes')}
							</span>
						</button>
					</li>
				</ul>
			)}
		</AdvisorNotesModalController>
	);
}